export enum TriangleRotationStatus {
    TOP_RIGHT = 4,
    TOP_LEFT = 1,
    BOTTOM_RIGHT = 3,
    BOTTOM_LEFT = 2
}

export namespace TriangleRotationStatus {
    export function getOpposite(status: TriangleRotationStatus): TriangleRotationStatus {
      switch (status) {
        case TriangleRotationStatus.TOP_LEFT: return TriangleRotationStatus.BOTTOM_RIGHT;
        case TriangleRotationStatus.TOP_RIGHT: return TriangleRotationStatus.BOTTOM_LEFT;
        case TriangleRotationStatus.BOTTOM_LEFT: return TriangleRotationStatus.TOP_RIGHT;
        case TriangleRotationStatus.BOTTOM_RIGHT: return TriangleRotationStatus.TOP_LEFT;
        default: throw new Error(`Triangle rotation status ${status} not described.`);
      }
    }
  }